export default "__VITE_ASSET__T6BDr3bd__"